import moment from 'moment';
import { IReferenceData } from '../../interfaces/form/reference-data.model';

export interface IStudentProfile {
  id?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  dob?: string;
  sex?: string;
  ethnicity?: string;
  hispanicFlag?: string;
  phoneNumber?: string;
  email?: string;
  homeLanguage?: string;
}

export interface IStudentAddress {
  streetNum?: string;
  street?: string;
  apartmentFloor?: string;
  city?: string;
  boro?: string;
  district?: string;
  state?: string;
  zip?: string;
}

export interface IStudentProfileSubmitData {
  nycId?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  dateOfBirth?: Date;
  gender?: IReferenceData;
  ethnicity?: IReferenceData[];
  hispanicFlag?: string;
  phoneNumber?: string;
  email?: string;
  homeLanguage?: IReferenceData;
  streetNumber?: string;
  streetName?: string;
  apartmentNo?: string;
  city?: string;
  borough?: IReferenceData;
  district?: IReferenceData;
  state?: IReferenceData;
  zip?: string;
}

export class StudentProfileSubmitModel {
  student: IStudentProfile;
  address: IStudentAddress;
  submittedBy: string;

  constructor(data: Partial<IStudentProfileSubmitData>) {
    this.student = {
      id: data?.nycId,
      firstName: data?.firstName,
      middleName: data?.middleName,
      lastName: data?.lastName,
      dob: data?.dateOfBirth
        ? moment(data?.dateOfBirth).format('YYYYMMDD')
        : '',
      sex: String(data?.gender ? data?.gender?.value : data?.gender ?? ''),
      ethnicity: this.getEthnicityValues(data?.ethnicity),
      hispanicFlag: data?.hispanicFlag,
      phoneNumber: data?.phoneNumber,
      email: data?.email,
      homeLanguage: data?.homeLanguage?.value,
    };
    this.address = {
      streetNum: data?.streetNumber,
      street: data?.streetName,
      apartmentFloor: data?.apartmentNo,
      city: data?.city,
      boro: String(data?.borough ? data?.borough?.value : data?.borough ?? ''),
      district: String(data?.district ? data?.district?.value : data?.district ?? ''),
      state: String(data?.state ? data?.state?.value : data?.state ?? ''),
      zip: data?.zip,
    };
  }

  getEthnicityValues(ethnicity?: IReferenceData[]): string {
    if (ethnicity) {
      const ethnicityCode: string[] = [];
      ethnicity.forEach((code: IReferenceData) => {
        ethnicityCode.push(code.value);
      });
      return ethnicityCode.join(',');
    } else {
      return '';
    }
  }
}
